module.exports = __webpack_public_path__ + "static/media/city.8b20bf35.jpg";